import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { UiComponents } from "@simulanisindia/ui";
import BtnLoad from "../common/BtnLoad";
import { AddProjectLightIcon } from "../../Assest/icons/icons";

const { SimInputBar, DropdownSearch } = UiComponents;

const AddTask = ({ showAddTask, handleCloseAddTask, addNewTaskToList, scenarioList, locked }) => {
  const [error, setError] = useState(false);
  const [task, setTask] = useState({
    title: "",
    plannedTime: "",
    priority: "",
    taskDesc: "",
    isCritical: false,
    scenario: null,
    id: null
  });

  let options = scenarioList.map(item => ({
    value: item.id,
    label: item.name
  }));;

  const handleChangeTaskValue = (e) => {
    const name = e.target.name;
    const value = e.target.name == "isCritical" ? !task.isCritical : e.target.value;
    setTask({
      ...task,
      [name]: e.target.name == "isCritical" ? value : value.startsWith("0") ? value.slice(1) : value
    });
  }

  const handleClose = () => {
    setTask({
      id: null,
      title: "",
      plannedTime: "",
      priority: "",
      taskDesc: "",
      isCritical: false,
      scenario: null,
    });
    handleCloseAddTask();
  }

  const createTask = () => {

    if (task.title && task.plannedTime && task.priority && task.taskDesc) {

      if (locked && task.id === null) {
        setError(true);
        setTimeout(() => setError(false), 2500);
        return;
      }

      addNewTaskToList(task);
      setTask({
        id: null,
        title: "",
        plannedTime: "",
        priority: "",
        taskDesc: "",
        isCritical: false,
        scenario: null,
      });


    } else {
      setError(true);
      setTimeout(() => { setError(false) }, 2500);
    }
  }

  const handleScenarioChange = (selectedOption) => {
    setTask({
      ...task,
      scenario: selectedOption.value
    });
  };
  return (
    <>
      <Modal show={showAddTask} centered onHide={handleClose} className="createModal">
        <div className="customModalHead">
          <div className="filterbtn">
            <div className="btninadjust">
              <AddProjectLightIcon />
            </div>
          </div>
          <h6>Add Task</h6>
        </div>
        <Modal.Body>
          <div className="projectCreation">
            <div className="inputItem ">
              <p>Title</p>
              <SimInputBar
                name="title"
                placeholder="Enter task title"
                value={task.title}
                onChange={handleChangeTaskValue}
              />
            </div>

            <div className="inputItem mt-3">
              <p>Time</p>
              <SimInputBar
                type="number"
                name="plannedTime"
                placeholder="Enter time in minutes"
                value={task.plannedTime}
                onChange={handleChangeTaskValue}
              />
            </div>

            <div className="inputItem mt-3">
              <p>Priority</p>
              <SimInputBar
                type="number"
                name="priority"
                placeholder="Enter priority level (1-10)"
                value={task.priority}
                onChange={handleChangeTaskValue}
              />
            </div>

            {/* <div className="inputItem mt-3">
              <p>Scenario</p>
              <DropdownSearch
                label=""
                selectProps={{
                  options: options,
                  value: options.find(option => option.value === task.scenario),
                  placeholder: "Select scenario...",
                  onChange: handleScenarioChange,
                }}
              />
            </div> */}

            <div className="inputItem mt-3">
              <p>Description</p>
              <SimInputBar
                name="taskDesc"
                placeholder="Enter task description"
                value={task.taskDesc}
                onChange={handleChangeTaskValue}
                multiline
                rows={3}
              />
            </div>

            <div className="inputItem mt-3">
              <div className="checkbox-container">
                <label className="checkbox-label">
                  <input
                    type="checkbox"
                    name="isCritical"
                    checked={task.isCritical}
                    onChange={handleChangeTaskValue}
                    className="checkbox-input"
                  />
                  <span className="checkbox-text">Critical</span>
                </label>
              </div>
            </div>
          </div>
        </Modal.Body>
        <div className="modalFooterB">
          <button className="cancel" onClick={handleClose}>
            Cancel
          </button>
          <button className="save" onClick={createTask}>
            {"Save"}
          </button>
        </div>
      </Modal>
    </>
  );
};

export default AddTask;
